export const fr: Record<string, string> = {
  // Resource insights tooltip
  'lq.insights.loading': 'Chargement...',
  'lq.insights.noData': 'Aucune donnée',
  'lq.insights.capabilities': 'capacités',
  'lq.insights.domains': 'domaines',
  'lq.insights.natures': 'natures',
  'lq.insights.avgConsensus': 'consensus moyen',
  'lq.insights.of': 'sur {n}',

  // Rater tiers / counts
  'lq.raters.all': 'Les {n} évaluateurs',
  'lq.raters.one': '1 évaluateur',
  'lq.raters.some': '{k} évaluateurs sur {total}',
  'lq.ratersCount.one': '{n} évaluateur',
  'lq.ratersCount.many': '{n} évaluateurs',

  // Resource counts
  'lq.resourcesLinked.one': '{n} ressource associée',
  'lq.resourcesLinked.many': '{n} ressources associées',
  'lq.resourceCount.one': '{n} ressource',
  'lq.resourceCount.many': '{n} ressources',

  // Detail panel
  'lq.noDescription': 'Aucune description disponible.',
  'lq.consensusBreakdown': 'Répartition du consensus',
  'lq.loadingResources': 'Chargement des ressources...',
  'lq.linkedResources': 'Ressources associées',
  'lq.noResourcesLinkedYet': 'Aucune ressource associée pour le moment',

  // Cards & tooltips
  'lq.showDescription': 'Afficher la description',
  'lq.qualified': 'Qualifié·e',
  'lq.chosen': ' | {n} sélectionnée·s',

  // Qualification modal
  'lq.consensusThreshold': 'Consensus ≥{n}/{total}',
  'lq.selectedShort': '{n} sél.',
  'lq.resetSelections': 'Réinitialiser la sélection',
  'lq.manualOverride': 'Ajustement manuel — déplacez le curseur pour réinitialiser',
  'lq.viewOnly': 'Lecture seule — accès administrateur requis pour modifier',
  'lq.emptyState.title': 'Aucune ressource associée',
  'lq.emptyState.desc': 'Rendez-vous d’abord dans la phase d’Association pour ajouter des ressources à cette capacité.',
  'lq.unclassified.label': 'Ressources non classées',
  'lq.unclassified.hint': 'Ces ressources n’ont pas de classification de fonction ou de type',
  'lq.saving': 'Enregistrement...',
  'lq.saveAndClose': 'Enregistrer et fermer',

  // Consensus stacked bar
  'lq.noResources': 'Aucune ressource',
  'lq.bar.tooltip': 'k={k} : {active} actives{excluded} ({total} au total)',
  'lq.bar.excluded': ', {n} exclues',

  // CSV actions
  'lq.csv.importLabel': 'Importer un CSV',
  'lq.csv.exportLabel': 'Exporter en CSV',

  // Alerts
  'lq.alert.csvEmpty': 'Le fichier CSV est vide ou ne contient aucune ligne de données.',
  'lq.alert.importComplete': 'Importation terminée : {imported} sélections importées, {skipped} ignorées.',
  'lq.alert.importFailed': 'Échec de l’importation : {msg}',
  'lq.alert.saveFailed': 'Échec de l’enregistrement des sélections',
};

export const en: Record<string, string> = {
  // Resource insights tooltip
  'lq.insights.loading': 'Loading...',
  'lq.insights.noData': 'No data',
  'lq.insights.capabilities': 'capabilities',
  'lq.insights.domains': 'domains',
  'lq.insights.natures': 'natures',
  'lq.insights.avgConsensus': 'avg consensus',
  'lq.insights.of': 'of {n}',

  // Rater tiers / counts
  'lq.raters.all': 'All {n} raters',
  'lq.raters.one': '1 rater',
  'lq.raters.some': '{k} of {total} raters',
  'lq.ratersCount.one': '{n} rater',
  'lq.ratersCount.many': '{n} raters',

  // Resource counts
  'lq.resourcesLinked.one': '{n} resource linked',
  'lq.resourcesLinked.many': '{n} resources linked',
  'lq.resourceCount.one': '{n} resource',
  'lq.resourceCount.many': '{n} resources',

  // Detail panel
  'lq.noDescription': 'No description available.',
  'lq.consensusBreakdown': 'Consensus Breakdown',
  'lq.loadingResources': 'Loading resources...',
  'lq.linkedResources': 'Linked Resources',
  'lq.noResourcesLinkedYet': 'No resources linked yet',

  // Cards & tooltips
  'lq.showDescription': 'Show description',
  'lq.qualified': 'Qualified',
  'lq.chosen': ' | {n} chosen',

  // Qualification modal
  'lq.consensusThreshold': 'Consensus ≥{n}/{total}',
  'lq.selectedShort': '{n} sel.',
  'lq.resetSelections': 'Reset selections',
  'lq.manualOverride': 'Manual override — move slider to reset',
  'lq.viewOnly': 'View only — admin access required to edit',
  'lq.emptyState.title': 'No resources linked',
  'lq.emptyState.desc': 'Go to the Linking phase to add resources to this capability first.',
  'lq.unclassified.label': 'Unclassified Resources',
  'lq.unclassified.hint': 'These resources are missing function or type classification',
  'lq.saving': 'Saving...',
  'lq.saveAndClose': 'Save & Close',

  // Consensus stacked bar
  'lq.noResources': 'No resources',
  'lq.bar.tooltip': 'k={k}: {active} active{excluded} ({total} total)',
  'lq.bar.excluded': ', {n} excluded',

  // CSV actions
  'lq.csv.importLabel': 'Import CSV',
  'lq.csv.exportLabel': 'Export CSV',

  // Alerts
  'lq.alert.csvEmpty': 'CSV file is empty or has no data rows.',
  'lq.alert.importComplete': 'Import complete: {imported} selections imported, {skipped} skipped.',
  'lq.alert.importFailed': 'Import failed: {msg}',
  'lq.alert.saveFailed': 'Failed to save selections',
};
